export default defineNuxtPlugin(() => {
  onNuxtReady(async () => {
    const route = useRoute();
    const userStore = useUserStore();
    const whatsNew = useWhatsNew();

    // Avoid showing while auth/login redirect flows are resolving.
    if (route.path.includes("/loading")) return;

    if (userStore.isLoggedIn) {
      await whatsNew.maybeOpenWhatsNew();
    }

    watch(
      () => userStore.isLoggedIn,
      async (isLoggedIn, wasLoggedIn) => {
        if (!isLoggedIn || wasLoggedIn) return;
        if (route.path.includes("/loading")) return;
        await whatsNew.maybeOpenWhatsNew();
      },
    );
  });
});
